export const blockIconsFileAttachment = (
	<span className='material-symbols-outlined'>attachment</span>
);
